<template>
  <CModal class="modal__footer-empty" size="lg" :close-on-backdrop="false" :show="show" @update:show="closeModal">
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">VDP Article</span>
      </div>

      <CButtonClose @click="closeModal" />
    </template>

    <div class="subflow">
      <VVdpArticleForm :blog="blog" :show="show" />
    </div>
  </CModal>
</template>

<script>
import VVdpArticleForm from "@/components/Forms/VVdpArticleForm";
import { modalStore } from "@/mixins/modalsMixin";

export default {
  name: "TheVdpModal",

  components: {
    VVdpArticleForm
  },

  data: () => {
    return {}
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    currentUser() {
      return this[authStore.getterTypes.GETTER_USER]
    },
    blog() {
      const blog = this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`];
      return blog
    }
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    }
  }
};
</script>
<style>
.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
}
</style>